import { configAction } from "./action";
import { IConfigurationSubscriptionBundle } from "./interface";

export const initialConfigSubscriptionBundleState: IConfigurationSubscriptionBundle =
  {
    loaders: {
      getRegistrationLoader: false,
      registationDataLoader: false,
    },
    registrationData: {
      applicationId: "",
      registrationDate: new Date
    },
  };

export const configReducer = (
  state: IConfigurationSubscriptionBundle = initialConfigSubscriptionBundleState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case configAction.ADD_REGISTRATION_DATA:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          configSubscriptionLoader: true,
        },
      };
    case configAction.ADD_REGISTRATION_DATA_SUCCESS:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          configSubscriptionLoader: false,
        },
      };
    case configAction.ADD_REGISTRATION_DATA_FAILURE:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          configSubscriptionLoader: false,
        },
      };
    case configAction.GET_REGISTRATION_DATA:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          getSubscriptionLoader: true,
        },
      };

    case configAction.UPLOAD_COLLABORATIVE_SHARE:
      return {
        ...state,
        loaders: {
          ...state.loaders,
          configSubscriptionLoader: false,
        },
      };

    case configAction.GET_COLLABORATIVE_PERMISSION_LIST:
      return {
        ...state,
        collaborativePermissionList: action.payload,
        loaders: {
          ...state.loaders,
          configSubscriptionLoader: false,
        },
      };

    case configAction.GET_COLLABORATIVE_FORM_USER_LIST:
      return {
        ...state,
        collaborativeFormUserList: action.payload,
        loaders: {
          ...state.loaders,
          configSubscriptionLoader: false,
        },
      };

    default:
      return { ...state };
  }
};
